<template>
    <div class="category-container" :style="{width:selectedCategory? '100%':'180px'}">
        <!-- 左侧类目导航 -->
        <div class="left-nav">
            <div v-for="category in categories" :key="category.id" class="nav-item"
                :class="{ active: selectedCategory === category.id }" @mouseenter="handleCategoryHover(category)"
                @mouseleave="handleCategoryLeave">
                <span>{{ category.name }}</span>
                <img src="@/assets/icon_next_arrow.png">
            </div>
        </div>

        <!-- 右侧内容 -->
        <div class="right-content" v-show="selectedCategory" @mouseenter="keepMenuVisible"
            @mouseleave="handleMenuLeave">
            <div class="dds" v-if="currentCategory">
                <!-- 品牌分组 -->
                <div v-for="brand in currentCategory.brands" :key="brand.id" class="brand-group" >
                    <h3 class="brand-title" @click.stop="selectBrand(brand)">{{ brand.name }}</h3>
                    <!-- 型号列表 -->
                    <div class="model-list">
                        <div v-for="(model, index) in brand.models.slice(0,6)" :key="index" class="model-item"
                            @click="selectModel(brand, model)">{{ model.title }}</div>
                            <div class="more" v-if="brand.models.length > 6" @click="selectBrand(brand)">搜索更多</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'Category',
    data() {
        return {
            currentIndex: 0,
            selectedCategory: null,
            hoverTimer: null,
            leaveTimer: null,
            currentIndex: 0,
            categories: [],
        }
    },
    computed: {
        ...mapGetters(['base']),
        currentCategory() {
            return this.categories.find(cat => cat.id === this.selectedCategory);
        }
    },
    watch: {

        base: {
            handler(newVal) {
                if (newVal.category && newVal.category.length > 0) {
                    this.categories = newVal.category.map(item => {
                        return {
                            id: item.id,
                            name: item.title,
                            brands: item.child.map(item2 => {
                                return {
                                    id: item2.id,
                                    name: item2.title,
                                    models: [...item2.goods]
                                }
                            })
                        }
                    })
                }
                // this.selectedCategory = this.categories[0].id;
            },
            immediate: true
        }
    },
    methods: {
        selectBrand(brand) {
            console.log("选中：", brand.name, brand.id);
            this.$router.push({ path: "/productinfo/"+brand.id+"?cateid="+brand.id });
        },
        mouseoverClick(index) {
            this.currentIndex = index;
        },
        handleCategoryHover(category) {
            clearTimeout(this.leaveTimer);
            if (category.brands.length > 0) {
                this.hoverTimer = setTimeout(() => {
                    this.selectedCategory = category.id;
                }, 150);
            }
        },
        handleCategoryLeave() {
            clearTimeout(this.hoverTimer);
            this.leaveTimer = setTimeout(() => {
                this.selectedCategory = null;
            }, 200);
        },
        keepMenuVisible() {
            clearTimeout(this.leaveTimer);
        },
        handleMenuLeave() {
            this.handleCategoryLeave();
        },
        selectModel(brand, model) {
            console.log("选中：", model.title, model.id);
            this.$router.push({ path: "/buyproduct/"+model.id+'?cateid='+brand.id });
            this.handleMenuLeave();
        },
        navasClick(index) {
            this.navasIndex = index;
        },
    }
}
</script>

<style lang="less" scoped>
.category-container {
    display: flex;
    position: absolute;
    width: 180px;
    overflow: visible;
    z-index: 999;
}

/* 左侧导航样式 */
.left-nav {
    width: 180px;
    background: #ffffff;
    border-right: 1px solid #eee;
    height: 350px;
    margin-top: 10px;
    padding: 20px;
    box-sizing: border-box;
    box-shadow: 0px 0px 20px #eeeeee;
}

.nav-item {
    padding: 16px;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    color: rgba(102, 102, 102, 1);
}

.nav-item img {
    width: 16px;
    height: 16px;
}

.nav-item:hover {
    background: #ffffff;
    color: rgba(51, 51, 51, 1);
}

.nav-item.active {
    background: #fff;
    color: #F39800;
    font-weight: 500;
}

/* 右侧内容样式 */
.right-content {
    flex: 1;
    padding: 20px;
    background: #fff;
    margin-top: 10px;
    display: flex;
    flex-direction: row;

    width: 100%;
    box-sizing: border-box;
    box-shadow: 0px 0px 20px #eeeeee;
}

.brand-group {
cursor: pointer;
    width: calc(100% / 3 - 20px);
    display: flex;
    flex-direction: column;
}

.brand-title {
    margin: 0 0 12px 0;
    font-size: 16px;
    color: rgba(51, 51, 51, 1);
    font-weight: 700;
    padding-bottom: 8px;
    line-height: 20px;
}

.model-list {
    display: flex;
    flex-wrap: wrap;
    display: flex;
    flex-direction: column;
}
.more{
    color: #3c9c8f;
    cursor: pointer;
    font-size: 14px;
    margin-top: 10px;
    text-align: left;
    width: 100%;
    box-sizing: border-box;
    padding-right: 10px;
    &:hover{
        color: #3c9c8fbe;
    }
}
.model-item {
    padding: 10px 50px 0px 0px;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s;
    font-size: 14px;
    color: rgba(102, 102, 102, 1);
}

.dds {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 20px;
}

.model-item:hover {
    color: #3c9c8f;
}
</style>